module.exports = __webpack_public_path__ + "img/check.fa5bc5c0.svg";